import { render, staticRenderFns } from "./base-input-text.vue?vue&type=template&id=99435dd0&scoped=true&"
import script from "./base-input-text.vue?vue&type=script&lang=js&"
export * from "./base-input-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99435dd0",
  null
  
)

export default component.exports